import './clinica-fallback.css';

/**
 * Enquanto o código de uma página da clínica chega: na mesa, a moldura (barra lateral e o
 * lugar do conteúdo) fica no lugar; no bolso, o esqueleto de sempre.
 */
export function ClinicaFallback() {
  const desk =
    typeof document !== 'undefined' && document.documentElement.classList.contains('mesa-on');
  return (
    <div className={desk ? 'cf-desk' : 'cf-pocket'} aria-busy="true" aria-label="Abrindo">
      {desk && <div className="cf-side" />}
      <div className="cf-main">
        <span className="cf-bar w40" />
        <span className="cf-bar w70" />
        <span className="cf-block" />
      </div>
    </div>
  );
}
